export const USERS_LIST = 'users-list';
export const TASK_DATA_ARR = 'task-data-arr';

export const WO_QUES_DATA = 'wo-ques-data';
export const PR_HEADING_DATA = 'pr-heading-data';
export const PR_DATA = 'pr-data';
